<template lang="pug">
  split(style="height: 500px; background-color:#CCCCCC;")
    split-area(:size="25")
      | panel Left
    split-area(:size="75")
      | panel right
</template>
<script>
export default {
  data: () => ({})
};
</script>
<style scoped lang="stylus"></style>
